import * as React from 'react';
import { MathJaxContext, MathJax } from 'better-react-mathjax';

import './Block.scss';

export const BlockEquation = ({ equation }: any) => (
  <div className="block-equation">
    <MathJaxContext version={3} renderMode="pre">
      <MathJax text={equation.replace(/^\$\$|\$\$$/g, '')} typesettingOptions={{ fn: 'tex2chtml' }} />
    </MathJaxContext>
  </div>
);
